import { DataType } from "../../../../form/typings";
import { styleControlOptions } from "../../../../form/component-schema";
import i18n from "../../../i18n";
export default {
    $id: "modifiedTime",
    type: DataType.Object,
    $ref: styleControlOptions.$id,
    properties: {
        widgetType: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        format1: {
            type: DataType.String,
            title: i18n.t('dataitem.Format1').toString(),
            default: "YYYY-MM-DD HH:mm:ss",
        },
        format: {
            type: DataType.String,
            title: i18n.t('dataitem.Format').toString(),
            default: "YYYY-MM-DD HH:mm:ss",
        },
        syncFormate: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.SyncDefaultFormat').toString(),
            default: true,
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
    },
};
